export default __webpack_public_path__ + "static/media/mobileV.f4ed2844.svg";